import { removeCall } from 'store/callCenterSlice'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { addNotification } from 'store/notificationSlice'
import { Category } from 'hooks/useNotification'

interface WebPhoneCallWidgetProps {
    callId: string
    index: number
    removeFakeRingtone: () => void
}

// WebPhoneCallWidget is deprecated - RingCentral Web Phone integration removed
// All calls now use SoftPhoneCallWidget (Plivo/Livekit)
export const WebPhoneCallWidget = ({ callId, removeFakeRingtone }: WebPhoneCallWidgetProps) => {
    const dispatch = useDispatch()

    useEffect(() => {
        // Clean up immediately and notify user
        removeFakeRingtone()
        dispatch(removeCall(callId))
        dispatch(
            addNotification({
                id: '',
                message: 'Web phone calling is no longer supported. Please use the softphone option.',
                type: 'error',
                category: Category.Error,
                timestamp: Date.now(),
                topic: 'temp',
            })
        )
    }, [callId, dispatch, removeFakeRingtone])

    return null
}
